import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";
import store from "@/store";
import incubator from "./routes/incubator-route";
import home from "./routes/home";
import auth from "./routes/authPages";
import reception from "./routes/reception-routes";
import clinic from "./routes/clinic-routes";
import operations from "./routes/operations-routes";
import emergency from "./routes/emergancy-routes";
import surgery from "./routes/surgery-routes";
import lab from "./routes/lab-routes";
import radiology from "./routes/radiology-routes";
import warehouse from "./routes/warehouse-routes";
import employee from "./routes/employee-routes";
import pharmacy from "./routes/pharmacy-routes";
import ivf from "./routes/ivf-routes";
import hospital from "./routes/hospital-routes";
import seniorHouseOffice from "./routes/seniorHouseOffice-routes";
import accounting from "./routes/accounting-router";
import bloodBank from "./routes/bloodBank-routes";
import cashiers from "./routes/cashiers-routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "root",
      beforeEnter: (to, from, next) => {
        const isLoggedIn = isUserLoggedIn();
        if (!isLoggedIn) {
          next({ name: "auth-login" });
          return;
        }

        const userRole = JSON.parse(localStorage.getItem("userRole")); // Parse the JSON string
        console.log("userRole-root", userRole);
        const redirectPath = getHomeRouteForLoggedInUser(userRole);
        console.log("redirectPath-root", redirectPath);
        next(redirectPath);
      },
    },
    ...home,
    ...auth,
    ...reception,
    ...clinic,
    ...operations,
    ...emergency,
    ...surgery,
    ...lab,
    ...radiology,
    ...warehouse,
    ...employee,
    ...pharmacy,
    ...ivf,
    ...hospital,
    ...seniorHouseOffice,
    ...accounting,
    ...bloodBank,
    ...incubator,
    ...cashiers,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: "auth-login" });

    // If logged in => not authorized
    // return next({ name: 'error-404' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    console.log("userData", userData);
    next(getHomeRouteForLoggedInUser(userData ? "admin" : null));
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
